import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Screen } from '../../components/Screen/Screen';
import { ScreenHeader } from '../../components/ScreenHeader/ScreenHeader';
import { ProgressIndicator } from '../../components/ProgressIndicator/ProgressIndicator';
import { Button } from '../../components/Button/Button';
import { TextInput } from '../../components/TextInput/TextInput';
import { copy, labels, validation } from '../../constants';
import { useOnboardingStore } from '../../store/onboarding';
import type { Province } from '../../types';

export const Location: React.FC = () => {
  const navigate = useNavigate();
  const { data, updateData, setStep } = useOnboardingStore();
  const [error, setError] = useState('');

  const province = data.province || 'AB';
  const city = data.city || '';

  const provinces = Object.entries(labels.provinces).map(([value, label]) => ({
    value,
    label
  }));

  const handleContinue = () => {
    if (!province) {
      setError(validation.provinceRequired);
      return;
    }
    
    setStep(8);
    navigate('/contact');
  };

  return (
    <Screen>
      <ProgressIndicator currentStep={7} totalSteps={8} />
      
      <ScreenHeader
        title={copy.location.title}
      />
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)' }}>
        <div>
          <label htmlFor="province" style={{ 
            display: 'block',
            marginBottom: 'var(--spacing-xs)',
            fontSize: 'var(--font-size-base)',
            fontWeight: 'var(--font-weight-medium)',
            color: 'var(--color-text-primary)'
          }}>
            {copy.location.provinceLabel} <span style={{ color: 'var(--color-error)' }}>*</span>
          </label>
          <select
            id="province"
            value={province}
            onChange={(e) => {
              setError('');
              updateData({ province: e.target.value as Province });
            }}
            style={{
              width: '100%',
              padding: '14px 16px',
              fontSize: 'var(--font-size-base)',
              color: 'var(--color-text-primary)',
              backgroundColor: 'var(--color-surface)',
              border: `2px solid ${error ? 'var(--color-error)' : 'var(--color-border)'}`,
              borderRadius: 'var(--radius-md)',
              cursor: 'pointer'
            }}
          >
            <option value="">Select a province</option>
            {provinces.map((prov) => (
              <option key={prov.value} value={prov.value}>
                {prov.label}
              </option>
            ))}
          </select>
          {error && (
            <div style={{ 
              marginTop: 'var(--spacing-xs)',
              fontSize: 'var(--font-size-sm)',
              color: 'var(--color-error)'
            }}>
              {error}
            </div>
          )}
        </div>
        
        <TextInput
          label={copy.location.cityLabel}
          value={city}
          onChange={(value) => updateData({ city: value })}
          placeholder={copy.location.cityPlaceholder}
        />
      </div>
      
      <div style={{ marginTop: 'var(--spacing-lg)' }}>
        <Button
          variant="primary"
          size="large"
          fullWidth
          onClick={handleContinue}
        >
          {copy.location.button}
        </Button>
      </div>
    </Screen>
  );
};
